import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'mrsoftapps-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent {
  @Input() query = '';
  @Input() searching = false;
  @Input() searchByDate: boolean;
  @Input() error = '';
  @Input() name;
  @Output() search = new EventEmitter<string>();
  @Output() searchDate = new EventEmitter<string>();
  searchForm: FormGroup;
  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
    this.searchForm = this.fb.group({
      startDate: [''],
      endDate: [''],
    });
  }

  onSearch(value) {
    value.startDate = new Date(value.startDate).getTime();
    value.endDate = new Date(value.endDate).getTime();
    this.searchDate.emit(value);
  }
}
